import React, { PropsWithChildren } from 'react';
import { Tab } from '@headlessui/react';
import { cn } from '@/utils/cn';
import { TabSize } from './types';
interface Props extends PropsWithChildren {
  size: TabSize;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  isProductsHeader?: boolean;
}
const TabItem = ({
  disabled,
  size,
  onClick,
  children,
  className,
  isProductsHeader
}: Props) => {
  return <Tab onClick={onClick} disabled={disabled} className={({
    selected
  }) => cn('relative w-full whitespace-nowrap rounded border border-border-gray-light bg-surface-solid-0 px-6 py-1.5 text-center focus:outline-none', {
    'after:opacity-100': selected,
    'py-2 text-body-16 font-medium': size === TabSize.Large,
    'py-1.5 text-body-14 font-medium': size === TabSize.Medium,
    'text-text-lightGray': !selected && disabled,
    'text-text-mediumGray': !selected && !disabled
  }, selected && (isProductsHeader ? 'text-primary-main after:absolute after:bottom-0 after:left-0 after:z-[20] after:h-[2px] after:w-full after:rounded-none after:bg-primary-main after:content-[""]' : 'border-border-pink text-primary-main shadow-sm'), {
    'flex-1 overflow-hidden truncate px-1': isProductsHeader
  }, className)} data-sentry-element="Tab" data-sentry-component="TabItem" data-sentry-source-file="tab-item.tsx">
            {children}
        </Tab>;
};
export default TabItem;